import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { Box, Grid } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import * as Converter from "persian-currency-converter";
import ModalPaymentReceipt from "../modals/ModalPaymentReceipt";
import { Button } from "react-bootstrap/lib/InputGroup";
import ViewCheckInformationModal from "../../pages/detail/ViewCheckInformationModal";
import ModalOverduePaymentReceipt from "../modals/ModalOverduePaymentReceipt";
import ModalCurrentPaymentReceipt from "../modals/ModalCurrentPaymentReceipt";

export default function DivisionInstallment(props: any) {
    let headerColor: any;
    const [openModal, setOpenModal] = useState(false);
    const [openModalOverdue, setOpenModalOverdue] = useState(false);
    const [openModalCurrent, setOpenModalCurrent] = useState(false);
    const [changeModal, setChangeModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(false);
    const [currentItemOverdue, setCurrentItemOverdue] = useState(false);
    const [currentItemCurrent, setCurrentItemCurrent] = useState(false);
    function getHeaderColor(state: string) {
        switch (props.data?.installments?.repaymentStatus) {
            case "Paid":
                headerColor = "#28A745"
            case "NotDue":
                headerColor = "#9AAFC4"
            case "Current":
                headerColor = "#1D4A87"
            case "Overdue":
                headerColor = "#E6123D"
        }
    }


    const click = (item: any) => {
        if (item.installments[0].repaymentStatus == "Paid") {
            setOpenModal(true);
            setCurrentItem(item)
        }
        if (item.installments[0].repaymentStatus == "Overdue") {
            setOpenModalOverdue(true);
            setCurrentItemOverdue(item)
        }
        if (item.installments[0].repaymentStatus == "Current") {
            setOpenModalCurrent(true);
            setCurrentItemCurrent(item)
        }
    }

    useEffect(() => {
        setOpenModal(changeModal);
    }, [setChangeModal])

    useEffect(() => {
        setOpenModalOverdue(changeModal);
    }, [setChangeModal])
    useEffect(() => {
        setOpenModalCurrent(changeModal);
    }, [setChangeModal])
    return (
        <div
            style={{
                width: "98%",
                margin: props.margin ? props.margin : "auto",
                background: "#fff",
                marginTop: props.marginTop ? props.marginTop : '1vh',
                paddingBottom: '2vh',
                marginBottom: '2vh',
                // props.color ? props.color : 
            }}

        >
            {props.title != null || props.title != undefined ? (
                <span
                    className="colorTitle fontWeight textFont16 mbottom10 "
                    style={{
                        marginTop: "-10px",
                        marginRight: "30px",
                        background: props.color ? "transparent" : "#fff",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                    }}
                >
                    {props.title}
                </span>
            ) : (
                ""
            )}
            <Box
                sx={{
                    p: 3,
                    border: "1px solid #C1C7CB",
                    borderRadius: "5px",
                    marginTop: "-14px",
                }}
                className="visible-print "
            >
                <div
                    className="tabsScrollInstallment"
                    style={{ height: "50vh" }}
                    id="scrollableDiv"
                >
                    {props.data != undefined && props?.data[0]?.cheque ? (
                        <Grid
                            container
                            xs={12}
                            style={{ marginTop: "4vh" }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                        >
                            {props.data?.map((item: any) => {
                                return (
                                    <Grid
                                        item
                                        xs={6}
                                        style={{ paddingLeft: "3vh", marginBottom: "5vh" }}
                                    >
                                        <Grid
                                            container
                                            xs={12}
                                            style={{
                                                color: "#fff",
                                                backgroundColor: item.color,
                                                paddingLeft: "1vh",
                                            }}
                                        >
                                            <Grid
                                                item
                                                xs={10}
                                                style={{
                                                    transform: "translateY(25%)",
                                                    paddingRight: "1vh",
                                                }}
                                            >
                                                <p className=" textFont16 colorFFF">{item.status}</p>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={2}
                                                style={{
                                                    transform: "translateY(25%)",
                                                    display: "flex",
                                                    justifyContent: "left",
                                                    paddingLeft: "10px",
                                                }}
                                            >
                                                <ViewCheckInformationModal fileData={item.cheque} />
                                            </Grid>
                                        </Grid>
                                        <>
                                            <Grid
                                                container
                                                xs={12}
                                                style={{ border: "1px solid #DAE0E4" }}
                                            >
                                                <Grid
                                                    item
                                                    xs={6}
                                                    style={{ borderLeft: "1px solid #DAE0E4" }}
                                                >
                                                    {item.installments?.map((install: any) => {
                                                        return (
                                                            <Grid
                                                                item
                                                                xs={12}
                                                                style={{
                                                                    borderBottom:
                                                                        item.installments.length > 1
                                                                            ? "1px solid #DAE0E4"
                                                                            : "",
                                                                    marginRight: "1vh",
                                                                }}
                                                            >
                                                                <p
                                                                    className="textFont16 colorTitle"
                                                                    style={{
                                                                        marginRight: "1vh",
                                                                        marginTop: "2vh",
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    قسط شماره &nbsp;
                                                                    {Converter.convertToPersianWord(
                                                                        install.rowNumber
                                                                    )}{" "}
                                                                </p>
                                                                <p
                                                                    className="textFont12 colorTitle"
                                                                    style={{
                                                                        marginRight: "1vh",
                                                                        marginBottom: "2vh",
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    تاریخ سررسید &nbsp;
                                                                    <span className="fontWeight">
                                                                        {install.dueDate_Persian}
                                                                    </span>{" "}
                                                                    - مبلغ به عدد &nbsp;
                                                                    <span className="fontWeight">
                                                                        {install.amount.toLocaleString()}{" "}
                                                                    </span>{" "}
                                                                    ریال{" "}
                                                                </p>
                                                                {install.insuranceAmount > 0 ?
                                                                    <p
                                                                        className="textFont12 colorTitle"
                                                                        style={{
                                                                            marginRight: "1vh",
                                                                            marginBottom: "2vh",
                                                                        }}
                                                                    >
                                                                        {" "}
                                                                        مبلغ بیمه &nbsp;
                                                                        <span className="fontWeight">
                                                                            {install.insuranceAmount.toLocaleString()} ریال
                                                                        </span>
                                                                    </p> : ""
                                                                }

                                                            </Grid>
                                                        );
                                                    })}
                                                </Grid>
                                                <Grid item xs={6} style={{ display: "grid" }}>
                                                    <Grid item xs={12}>
                                                        {item.accumulativeLoaded ? (
                                                            <p className="navbarAccumulative">
                                                                تجمیعی &nbsp;
                                                                {item.cheque.accumulativeAmount.toLocaleString()}
                                                                ریال
                                                            </p>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        style={{
                                                            alignSelf: "center",
                                                            height: "100%",
                                                            display: "block",
                                                            marginRight: "1vh",
                                                            marginLeft: "1vh",
                                                            paddingTop: "2vh",
                                                            paddingBottom: "2vh",
                                                        }}
                                                    >
                                                        {item.cheque.inquiryDueDatePersian ? (
                                                            <>
                                                                <span className=" textFont12 colorTitle">
                                                                    {" "}
                                                                    تاریخ سررسیداستعلام شده: &nbsp;
                                                                    <span
                                                                        className="fontWeight"
                                                                        style={
                                                                            item.dueDatePersian! !=
                                                                                item.inquiryDueDatePersian! &&
                                                                                item.inquiryDueDatePersian!
                                                                                ? {
                                                                                    backgroundColor: "#ee9d01",
                                                                                    color: "#fff",
                                                                                    borderRadius: "5px",
                                                                                    paddingRight: "5px",
                                                                                    paddingLeft: "5px",
                                                                                }
                                                                                : item.dueDatePersian! !=
                                                                                    item.inquiryDueDatePersian! &&
                                                                                    item.inquiryDueDatePersian!
                                                                                    ? {
                                                                                        backgroundColor: "#28a745",
                                                                                        color: "#fff",
                                                                                        borderRadius: "5px",
                                                                                        paddingRight: "5px",
                                                                                        paddingLeft: "5px",
                                                                                    }
                                                                                    : { backgroundColor: "#fff" }
                                                                        }
                                                                    >
                                                                        {item.cheque.inquiryDueDatePersian}
                                                                    </span>
                                                                    <br />
                                                                    <br />
                                                                </span>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <span>
                                                            {/* <span className=" textFont16 colorTitle fontWeight" style={{ marginRight: '2vh' }}>چک</span><br></br> */}

                                                            <span className=" textFont12 colorTitle">
                                                                {" "}
                                                                چک به تاریخ سررسید &nbsp;
                                                                <span className="fontWeight">
                                                                    {item.cheque.dueDatePersian}
                                                                </span>{" "}
                                                                - مبلغ به عدد &nbsp;
                                                                <span className="fontWeight">
                                                                    {item.cheque.inquiryAmount
                                                                        ? item.cheque.inquiryAmount.toLocaleString()
                                                                        : item.cheque.amount.toLocaleString()}
                                                                </span>{" "}
                                                                ریال
                                                            </span>
                                                            {item.cheque.sayadNumber ? (
                                                                <>
                                                                    <br />
                                                                    <br />
                                                                    <span className=" textFont12 colorTitle">
                                                                        {" "}
                                                                        شماره صیادی &nbsp;
                                                                        <span className="fontWeight">
                                                                            {item.cheque.sayadNumber}
                                                                        </span>
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}
                                                            {item.cheque.seriesNo && item.cheque.serialNo ? (
                                                                <>
                                                                    <br />
                                                                    <br />
                                                                    <span className=" textFont12 colorTitle">
                                                                        سری و سریال: &nbsp;
                                                                        <span className="fontWeight">
                                                                            {item.cheque.seriesNo}
                                                                        </span>
                                                                        &nbsp; / &nbsp;
                                                                        <span className="fontWeight">
                                                                            {item.cheque.serialNo}
                                                                        </span>
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </span>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )

                        :
                        <Grid container xs={12} style={{ marginTop: '4vh' }} columns={{ xs: 4, sm: 8, md: 12 }}>
                            {props.data?.map((item: any) => {

                                return (
                                    <Grid item xs={6} style={{ paddingLeft: '3vh', marginBottom: '5vh' }}>

                                        <>
                                            <Grid container xs={12} style={{ border: '1px solid #DAE0E4' }}>
                                                <Grid item xs={12}>
                                                    <span onClick={() => click(item)}>
                                                        {item.installments?.map((install: any) => {
                                                            return (
                                                                <Grid container xs={12}>
                                                                    <Grid container xs={12} style={{
                                                                        color: '#fff', backgroundColor: install.repaymentStatus == "Paid" ?
                                                                            "#28A745" : install.repaymentStatus == "NotDue" ? "#9AAFC4" : install.repaymentStatus == "Current" ? "#1D4A87" :
                                                                                install.repaymentStatus == "Overdue" ? "#E6123D" : "", paddingLeft: '1vh'
                                                                    }} >
                                                                        <Grid item xs={10} style={{ transform: 'translateY(25%)', paddingRight: '1vh' }}>

                                                                            <p className=" textFont16 colorFFF" >{install.repaymentStatusTitle}</p>
                                                                        </Grid>

                                                                        <Grid item xs={2} style={{
                                                                            transform: 'translateY(25%)', display: 'flex', justifyContent: 'left',
                                                                            paddingLeft: '10px'
                                                                        }}>
                                                                            <p>{install.dueDate_Persian ? install.dueDate_Persian : " --/--/----"}</p>
                                                                        </Grid>

                                                                    </Grid>
                                                                    <Grid item xs={12} style={{ marginRight: '1vh' }}>
                                                                        <p className="textFont16 colorTitle" style={{ marginRight: '1vh', marginTop: '2vh' }}> قسط شماره
                                                                            &nbsp;{Converter.convertToPersianWord(install.rowNumber)} </p>
                                                                        <p className="textFont12 colorTitle" style={{ marginRight: '1vh', marginBottom: '2vh' }}>   تاریخ سررسید
                                                                            &nbsp;<span className="fontWeight">{install.dueDate_Persian}</span> - مبلغ به عدد
                                                                            &nbsp;<span className="fontWeight">{install.amount.toLocaleString()} </span> ریال </p>
                                                                        {install.insuranceAmount > 0 ?
                                                                            <p
                                                                                className="textFont12 colorTitle"
                                                                                style={{
                                                                                    marginRight: "1vh",
                                                                                    marginBottom: "2vh",
                                                                                }}
                                                                            >
                                                                                {" "}
                                                                                مبلغ بیمه &nbsp;
                                                                                <span className="fontWeight">
                                                                                    {install.insuranceAmount.toLocaleString()} ریال
                                                                                </span>
                                                                            </p> : ""}

                                                                    </Grid>
                                                                </Grid>
                                                            )
                                                        })}
                                                    </span>
                                                </Grid>
                                            </Grid>
                                        </>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    }
                </div>
                <ModalPaymentReceipt
                    fileData={currentItem}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                />
                <ModalOverduePaymentReceipt
                    fileData={currentItemOverdue}
                    openModal={openModalOverdue}
                    setOpenModal={setOpenModalOverdue}
                />
                <ModalCurrentPaymentReceipt
                    fileData={currentItemCurrent}
                    openModal={openModalCurrent}
                    setOpenModal={setOpenModalCurrent}
                />
            </Box >
        </div>
    );
}
